export class EventTypes {
    Id: number;
    Name: string;
    DaysBeforeEvent: number;
    Color: string;
}